import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { exportTemplateShape, exportTemplateCreateShape, exportTemplateFilterShape } from './models'

export const exportTemplatesApi = createApi({
  client: axiosInstance,
  baseUri: '/expenses/export-templates/',
  models: {
    entity: exportTemplateShape,
    create: exportTemplateCreateShape,
    extraFilters: exportTemplateFilterShape,
  },
})
